// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"290":"drawings","535":"login","543":"equipment","630":"production","653":"machineTool","685":"register"}[chunkId] || chunkId) + ".[1699242360343].css";
};